import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';
import { Component } from '@grafikr/components';

import Modal from 'utils/components/modal';
import { HAS_SELECTED_STORAGE_KEY } from 'utils/loaders/has-matching-site';
import { dispatch } from 'utils/theme';

export default Component((node, { onTriggered }) => {
  const modal = new Modal(node);
  const closeTriggers = node.querySelectorAll('[data-close]');

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', modal.close);
  });

  modal.on('open', () => {
    disablePageScroll();
  });

  modal.on('close', () => {
    localStorage.setItem(HAS_SELECTED_STORAGE_KEY, 'true');

    enablePageScroll();
  });

  onTriggered(() => {
    switch (node.dataset.move) {
      case 'body':
        document.body.append(node);
        break;
    }

    if (node.dataset.accountId) {
      dispatch('account-open-modal', {
        name: node.dataset.accountId,
      });
    }

    modal.open();
  });
});
